import { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { api, assetUrl } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUploader({ value, onChange, label, testid }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Imagine încărcată");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Încărcare eșuată");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-ink/20 p-3">
      {label && <div className="eyebrow text-ink/50 mb-2">{label}</div>}
      <div className="flex items-start gap-3">
        <div className="w-24 h-24 shrink-0 bg-ink/5 border border-ink/10 overflow-hidden flex items-center justify-center">
          {value ? (
            <img src={assetUrl(value)} alt="" className="w-full h-full object-cover" />
          ) : (
            <span className="eyebrow text-ink/30">—</span>
          )}
        </div>
        <div className="flex-1 space-y-2">
          <input
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="URL imagine sau încarcă"
            data-testid={testid ? `${testid}-url` : undefined}
            className="w-full bg-transparent border border-ink/20 px-2 py-1.5 text-xs outline-none focus:border-ink"
          />
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => inputRef.current?.click()}
              disabled={busy}
              data-testid={testid ? `${testid}-btn` : undefined}
              className="eyebrow inline-flex items-center gap-2 border border-ink px-3 py-1.5 hover:bg-ink hover:text-paper transition-colors disabled:opacity-50"
            >
              {busy ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />}
              Încarcă
            </button>
            {value && (
              <button
                type="button"
                onClick={() => onChange("")}
                className="eyebrow inline-flex items-center gap-1 border border-ink/30 px-3 py-1.5 hover:bg-ink/10 transition-colors"
              >
                <X size={13} /> Șterge
              </button>
            )}
          </div>
        </div>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => upload(e.target.files?.[0])}
      />
    </div>
  );
}
